import { Search } from 'lucide-react';

import { Button } from '@/shared/components/shadcn/button';

interface Props {
  onRewritePrompt: () => void;
}

export function CreatorsResultsLowFullMatchGuidance({ onRewritePrompt }: Props) {
  return (
    <div className="border-foreground bg-foreground flex items-center justify-between gap-4 rounded-xl border px-4 py-3 shadow-sm">
      <div className="flex min-w-0 items-center gap-3">
        <div className="bg-background/10 ring-background/10 shrink-0 rounded-full p-1.5 ring-1">
          <Search className="text-background size-3.5" />
        </div>
        <div className="min-w-0">
          <p className="text-background text-sm leading-5 font-medium">
            Only a few creators fully match your prompt
          </p>
          <p className="text-background/70 mt-0.5 text-sm leading-5">
            Try broadening your prompt to uncover more relevant creators.
          </p>
        </div>
      </div>

      <div className="flex shrink-0 items-center gap-2">
        <Button
          variant="secondary"
          size="sm"
          className="bg-background text-foreground hover:bg-muted"
          onClick={onRewritePrompt}
        >
          Rewrite prompt
        </Button>
      </div>
    </div>
  );
}
